import { mapState, mapMutations, mapActions } from 'vuex'
import { GENERAL_STORE } from '../store'

export default {
  data: () => ({
    ws: null,
    isLoading: true,
    isShowErrorMessage: false,
    isNeedSocket: true,
    tryToConnectIteration: 0,
    socketConnect: false,
    isShowIframe: false,
  }),
  computed: {
    ...mapState(GENERAL_STORE, ['user']),
    socket() {
      return this.user.socket
    },
    timeoutToConnect() {
      return this.tryToConnectIteration <= 30 ? 1000 : 5000
    },
  },
  methods: {
    ...mapMutations(GENERAL_STORE, [
      'toggleModals',
      'updateOrder',
      'setWarningMessage',
      'addNewPaymentCard',
    ]),
    ...mapActions(GENERAL_STORE, ['submitOrder', 'blockOrderButton']),

    closeConnection() {
      this.isNeedSocket = false
      this.ws.close()
      this.toggleModals()
    },
    load() {
      this.isLoading = !this.socketConnect
    },
    connect() {
      this.ws = new WebSocket(`${this.socket.url}?token=${this.socket.token}`)

      this.ws.onmessage = evt => {
        this.isLoading = true

        const res = JSON.parse(evt.data)
        const isSuccess = res.action === 'bank_card_recurrent_acepted'

        if (isSuccess) {
          const card = {
            mask: res.message.card,
            type: res.message.type,
            id: res.message.id.toString(),
          }

          this.addNewPaymentCard(card)
          this.updateOrder({
            key: 'selectedCard',
            value: card,
          })
          this.submitOrder()
          this.closeConnection()
          this.blockOrderButton()
        } else {
          this.$nextTick(() => {
            this.setWarningMessage({
              body: res.message.text ?? 'Не удалось совершить оплату картой. Обратитесь в тех. поддержку.',
            })
            this.toggleModals('warningMessage')
          })
          this.closeConnection()
        }
      }

      // При закрытии сокета пробуем реконнектиться, если нужен сокет
      this.ws.onclose = () => {
        if (this.isNeedSocket) {
          this.socketConnect = false
          this.isLoading = true
          this.isShowErrorMessage = true
          this.tryToConnectIteration += 1
          setTimeout(() => {
            this.connect()
          }, this.timeoutToConnect)
        }
      }

      this.ws.onerror = () => {
        this.ws.close()
      }

      this.ws.onopen = () => {
        this.tryToConnectIteration = 0
        this.socketConnect = true
        this.isLoading = false
      }
    },
  },
  mounted() {
    this.connect()

    // По какой-то причине v-if не видит своевременное обновление состояния socket, поля paymentUrl и соотвественно долгая загрузка iframe
    this.isShowIframe = setInterval(() => {
      if (this.socket.paymentUrl) {
        clearInterval(this.isShowIframe)
        this.isShowIframe = true
      }
    }, 300)
  },
}
